/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatedSiteDto } from '../../models/created-site-dto';
import { CreateSiteDto } from '../../models/create-site-dto';

export interface SiteControllerCreate$Params {
      body: CreateSiteDto
}

export function siteControllerCreate(http: HttpClient, rootUrl: string, params: SiteControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatedSiteDto>> {
  const rb = new RequestBuilder(rootUrl, siteControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatedSiteDto>;
    })
  );
}

siteControllerCreate.PATH = '/sites';
